<!-- Do not change this file. -->
<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-8">
        <div class="alert alert-primary fw-bold text-dark my-auto p-5 fs-3">
          Loading...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertLoading"
};
</script>
